import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { formatPercentHundredths, getIncreaseSymbol, isPositive } from '@bingads-webui-campaign/recommendation-core';

import template from './delta.pug';

export class CtrDeltaColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, isOptimizationScoreOn }) {
    const title = i18n.getString('Details_View_Est_CTR') || '__Weekly est. CTR__';

    super({
      name: 'CTR',
      property: 'EstimatedIncreaseInCtr',
      title,
      bodyClasses: ['grid-column-ctrIncrease'],
      colClasses: ['col-numberEst'],
      sortable: true,
      helpId: 'pop_BA_Recommendations_EstChangeCTRPer',
      type: 'number',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.isOptimizationScoreOn = isOptimizationScoreOn;
  }

  template({ value: { EstimatedIncreaseInCtr, CurrentCtr, CtrLift } }) {
    const { i18n, isOptimizationScoreOn } = this;
    if (!_.isNumber(CtrLift) || !_.isNumber(CurrentCtr) || CtrLift === 0) {
      return template({
        i18n,
        isNegative: false,
        notAvailable: true,
        isOptimizationScoreOn,
      });
    }
    return template({
      deltaVal: formatPercentHundredths(CtrLift, i18n),
      fromVal: formatPercentHundredths(CurrentCtr, i18n),
      toVal: formatPercentHundredths(CurrentCtr + EstimatedIncreaseInCtr, i18n),
      i18n,
      increaseSymbol: CurrentCtr > 0 ? getIncreaseSymbol(CtrLift, 'arrow') : getIncreaseSymbol(CtrLift),
      isNegative: !isPositive(CtrLift),
      isOptimizationScoreOn,
    });
  }

  get property() {
    return {
      get: _.identity,
      key: 'EstimatedIncreaseInCtr',
    };
  }
}
